export default __webpack_public_path__ + "static/media/clippers-fanshop.e5ec3b03.png";